import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toggleLike, toggleSave } from "../data/api/social";
import { patchFeedPost } from "../data/feedCache";

/**
 * Like/save mutations with an optimistic update against the
 * ["workoutFeed"] infinite-query cache, so the UI reacts instantly while
 * the (mocked) request resolves in the background.
 */
export function usePostEngagement() {
  const queryClient = useQueryClient();

  const likeMutation = useMutation({
    mutationFn: ({ postId, nextLiked }) => toggleLike(postId, nextLiked),
    onMutate: ({ postId, nextLiked, currentLikeCount }) => {
      patchFeedPost(queryClient, postId, {
        isLiked: nextLiked,
        likeCount: currentLikeCount + (nextLiked ? 1 : -1),
      });
    },
  });

  const saveMutation = useMutation({
    mutationFn: ({ postId, nextSaved }) => toggleSave(postId, nextSaved),
    onMutate: ({ postId, nextSaved }) => {
      patchFeedPost(queryClient, postId, { isSaved: nextSaved });
    },
  });

  return {
    toggleLike: (postId, currentLiked, currentLikeCount) =>
      likeMutation.mutate({ postId, nextLiked: !currentLiked, currentLikeCount }),
    toggleSave: (postId, currentSaved) =>
      saveMutation.mutate({ postId, nextSaved: !currentSaved }),
  };
}
